// src/utils/avatar-utils.ts

export const TOTAL_AVATARS = 15;

/**
 * Create a simple deterministic hash from a username.
 * The same name always returns the same index.
 */
export function avatarIndexFromName(name: string): number {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = (hash << 5) - hash + name.charCodeAt(i);
    hash |= 0; // Convert to 32bit int
  }
  hash = Math.abs(hash);
  return (hash % TOTAL_AVATARS) + 1; // 1–15
}

/**
 * Return the correct avatar image path for a given username.
 * Special case: AI players have specific avatars
 * Regular users: deterministic hash → m1-m15.png
 * Empty/null: falls back to "guest"
 */
export function defaultAvatarFor(username: string): string {
  const name = username || "guest";
  
  // Special case: AI players have specific avatars
  const aiAvatars: Record<string, string> = {
    "Lump": "./avatars/male/ai1.png",
    "Ferris": "./avatars/male/ai2.png",
    "Magnus": "./avatars/male/ai3.png",
    "Bot": "./avatars/male/ai0.png",
    "Sherlock": "./avatars/male/ai4.png",
    "AI Opponent": "./avatars/male/ai1.png",  // Legacy fallback
  };
  
  if (aiAvatars[name]) {
    return aiAvatars[name];
  }
  
  // Regular users get deterministic avatar based on username
  const index = avatarIndexFromName(name);
  return `./avatars/male/m${index}.png`;
}
